// export const BASE_URL = 'http://localhost:8668';
// export const BASE_URL = 'https://pera-revamp-uat-api.seedbox.ph';
// export const BASE_URL = 'https://preprod-api-pera.seedbox.ph';
export const BASE_URL = 'https://api.pera.seedbox.ph';

console.log(BASE_URL);
